import { http } from '@/utils/http'
import { AssetsType, StartupPageApi, UserType } from '@/types'

export const userInfoApi = () => {
  return http.get<UserType>(`/user`)
}

/* 成色表 */
export const chromaticsTableApi = () => {
  return http.get<StartupPageApi[]>(`/dialog/IOS`)
}

/* 静态资源接口 */
export const assetsApi = () => {
  return http.get<AssetsType>(`/asset`)
}

/* 未处理卖料订单数 */
export const pendingSettlementOrderApi = () => {
  return http.get(`/statement/pending`)
}

/* 价格提醒 */
export const priceRemindApi = (data) => {
  return http.post(`/alert/price`, data)
}
